import { com } from '@eidu/form'
import entityApiUrl from '../entity/baseUrl'
import AuthenticationContext from '../authorization/AuthenticationContext'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString

type CreateSemanticLinkParameters = {
  authContext: AuthenticationContext
  semanticLink: SemanticLink
}

const createSemanticLink = ({ authContext, semanticLink }: CreateSemanticLinkParameters): Promise<void> =>
  fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      'Content-Type': 'application/json',
    },
    body: serializeToJsonString(semanticLink),
  }).then(async (response) => {
    switch (response.status) {
      case 200:
        return
      default:
        throw Error(`Unexpected response code ${response.status} from createSemanticLink endpoint`)
    }
  })

export default createSemanticLink
